/**
 * @flow
 */
'use strict';

export const familyRelationCodes = [
{"code":"Father"},
{"code":"Mother"},
{"code":"Brother"},
{"code":"Sister"},
{"code":"Grandfather"},
{"code":"Grandmother"},
{"code":"Uncle"},
{"code":"Aunt"}
]

export const familyDiseaseSinceCodes = [
{"code":"Birth"},
{"code":"Childhood"},
{"code":"Adult onset"}
]

export const familyDiseaseCodes = [
{"code":"Cataract"},
{"code":"Glaucoma"},
{"code":"Amblyopia"},
{"code":"Aneurism"},
{"code":"Anisometropy"},
{"code":"Astigmatism"},
{"code":"Atrophy"},
{"code":"Blepharoplasty"},
{"code":"Blindness"},
{"code":"Chromosomal disease"},
{"code":"Chronic Uveitis"},
{"code":"Diabetic retinopathy"},
{"code":"Diabetis type 2"},
{"code":"Dry AMD"},
{"code":"Dryness"},
{"code":"Dystrophy"},
{"code":"Epilepsy"},
{"code":"Heart"},
{"code":"Hypercholesterol"},
{"code":"Hypermosis"},
{"code":"Hypoplasia"},
{"code":"Iridotomy"},
{"code":"Liver"},
{"code":"Macular hole"},
{"code":"Migraines"},
{"code":"Myopia"},
{"code":"Nystagmus"},
{"code":"Ocular occlusion"},
{"code":"Osteoporosis"},
{"code":"Plateau iris"},
{"code":"Probable Iridotomy"},
{"code":"Retinal problem"},
{"code":"Stargardt"},
{"code":"Strabismus"},
{"code":"Thalassemie"},
{"code":"Thyroid Cancer"},
{"code":"Trauma"},
{"code":"Vasculitis"},
{"code":"Wet AMD"},
]

export const medicalConditionCodes = [
{"code":"Diabetes"},
{"code":"High blood pressure"},
{"code":"Heart disease"},
{"code":"High cholesterol"},
{"code":"Thyroid problems"},
{"code":"Arthritis"},
{"code":"Cancer"},
{"code":"Headaches/Migraines"},
{"code":"No medical condition"}
]
